const INITIAL_STATE = {
  esperandoSolicitacao: false,
  valorParametro: null,
  alerta: {}
};

export default (state = INITIAL_STATE, action) => {

  switch (action.type) {
    case 'REQUERIMENTO_PARAMETROS_BUSCAR_POR_ID':
      return { ...state, esperandoSolicitacao: true, valorParametro: null, alerta: {} };
    case 'REQUERIMENTO_PARAMETROS_BUSCAR_POR_ID_SUCESSO':
      return { ...state, esperandoSolicitacao: false, valorParametro: action.payload, alerta: {} };
    case 'REQUERIMENTO_PARAMETROS_BUSCAR_POR_ID_ERRO':
      return {
        ...state, esperandoSolicitacao: false, valorParametro: null, alerta: { message: action.payload, severity: 'error' }
      };
    default:
      return state;
  }

}  
